// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kRvBseU6rNYhygFUI6Te{background-color:var(--background-primary-Inverted-primary);border:1px solid var(--border-neutral-default);border-radius:6px;max-width:540px;margin:12px 0 0 56px;padding:16px 12px 12px}.LrS886KRexQQJRkZ6LaE{color:var(--content-primary-tertiary);margin-bottom:15px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `kRvBseU6rNYhygFUI6Te`,
	"title": `LrS886KRexQQJRkZ6LaE`
};
export default ___CSS_LOADER_EXPORT___;
